document.addEventListener('click', (e) => {
  const loadMoreBtn = e.target.closest('#LoadMoreProducts');
  if (!loadMoreBtn) return;

  let currentPage = parseInt(loadMoreBtn.getAttribute('data-current-page'), 10);
  const totalPages = parseInt(loadMoreBtn.getAttribute('data-total-pages'), 10);
  const nextPage = currentPage + 1;

  const nextPageElements = document.querySelectorAll(`[data-page="${nextPage}"]`);
  nextPageElements.forEach(el => {
    el.classList.remove('hidden');
  });

  loadMoreBtn.setAttribute('data-current-page', nextPage);

  if (nextPage >= totalPages) {
    loadMoreBtn.parentElement.classList.add('hidden');
  }
});